import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import QuotationApi from '@infrastructure/quotation-api';
import { addSuccessNotification } from '../common/notificationSlice';
// export const getWorkOrdersListWithClientAsync = createAsyncThunk<WorkOrderListWithClientDto[], void, { rejectValue: ApiError | undefined }>(
//     'Quotation/GetWorkOrdersListWithClient',
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await QuotationApi.getWorkOrdersListWithClient();
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(getErrorPayload(error));
//         }
//     }
// );
export const getWorkOrdersListWithClientAsync = createAsyncThunk('debtor/GetContactPersonsByDebitorIdAsync', async (workOrderNumber, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await QuotationApi.getWorkOrdersListWithClientAsync(workOrderNumber);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createQuotationAsync = createAsyncThunk('Quotation/Create', async (quotationObject, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.createQuotation(quotationObject);
        dispatch(addSuccessNotification('Offerte succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllQuotationsAsync = createAsyncThunk('Quotation/GetAllQuotations', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await QuotationApi.getAllQuotations(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateQuotationAsync = createAsyncThunk('Quotation/Update', async (quotation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.updateQuotations(quotation.id, quotation);
        dispatch(addSuccessNotification('Offerte succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getQuotationByIdAsync = createAsyncThunk('Quotation/GetById', async (quotationId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await QuotationApi.getQuotationById(quotationId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllQuotationStatusAsync = createAsyncThunk('Quotation/getAllQuotationStatus', async (_, { rejectWithValue }) => {
    try {
        const response = await QuotationApi.getAllQuotationStatus();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createQuotationAmountAsync = createAsyncThunk('Quotation/CreateQuotationAmount', async (quotationAmount, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.createQuotationAmount(quotationAmount);
        dispatch(addSuccessNotification('Offerte bedrag succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllQuotationAmountsAsync = createAsyncThunk('Quotation/GetAllQuotationAmounts', async (quotationId, { rejectWithValue }) => {
    try {
        const response = await QuotationApi.getAllQuotationAmounts(quotationId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateQuotationAmountAsync = createAsyncThunk('Quotation/UpdateQuotationAmount', async (quotation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.updateQuotationAmount(quotation);
        dispatch(addSuccessNotification('Offerte Bedrag succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getQuotationAmountByIdAsync = createAsyncThunk('Quotation/GetQuotationAmountById', async (quotationId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await QuotationApi.getQuotationAmountById(quotationId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteQuotationAmountAsync = createAsyncThunk(`Quotation/DeleteQuotatonAmount`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.deleteQuotationAmount(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getQuotationPreviewAsync = createAsyncThunk('Quotation/GetQuotationPreview', async (quotationId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await QuotationApi.getQuotationPreview(quotationId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateQuotationAmountPositionAsync = createAsyncThunk('Quotation/updateQuotationAmountPosition', async (quotation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.updateQuotationAmountPosition(quotation);
        dispatch(addSuccessNotification('Offerte Bedrag succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteQuotationByIdAsync = createAsyncThunk(`Quotation/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.deleteQuotationById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateBulkQuotationAmountAsync = createAsyncThunk('Quotation/UpdateBulkQuotationAmount', async (quotation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await QuotationApi.updateBulkQuotationAmount(quotation);
        dispatch(addSuccessNotification('Record succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getQuotationNumberAsync = createAsyncThunk('workorder/WorkOrderNumber', async (workOrderId, { rejectWithValue }) => {
    try {
        const response = await QuotationApi.getQuotationNumber(workOrderId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateQuotationPdfAsync = createAsyncThunk(`Quotation/GenerateQuotationPdf`, async (command, { rejectWithValue }) => {
    try {
        const response = await QuotationApi.generateQuotationPdf(command);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllShippingMethodsAsync = createAsyncThunk('Quotation/GetShippingMethods', async (_, { rejectWithValue }) => {
    try {
        const response = await QuotationApi.getAllShippingMethod();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateQuotationPdfAsAttachmentAsync = createAsyncThunk(`Quotation/generateQuotationPdfAsAttachment`, async (command, { rejectWithValue }) => {
    try {
        const response = await QuotationApi.generateQuotationPdfAsAttachment(command);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
